module.exports = __webpack_public_path__ + "img/muvelet1.4baf69fb.png";